module.exports = __webpack_public_path__ + "static/media/VoterID_Sample.ca359d81.jpg";